import { useEffect } from 'react'
import ClientService from '../services/client.service'
import { useTranslation } from "react-i18next";



const useGetClients = (clientList, setClientList, addDefaultSelectItem) => {    

    const { t } = useTranslation();
    
    useEffect(()=> {

        const getData = async () => {
            try {
                const serviceResponse = await ClientService.getAllClients();
                const response = serviceResponse.data;
    
                if (addDefaultSelectItem) {
                    response.unshift({id: 0, name: t('data-lang-lbl-select')});
                }

                setClientList(response);
            }
            catch (error) {
            }
        }
        
        if (clientList === null) {
            getData()
        }
    }, [t, clientList, setClientList, addDefaultSelectItem]);
}
 
export { useGetClients }